import React from "react";
import "./css/bootstrap.css";
import "./css/style.css";
import "./css/magnific-popup.css";
import "./css/iconfont-style.css";
import "./css/animate.css";
import "./css/bootstrap-datepicker3.min.css";

var htmlDoc = {
  __html: `<div class="landingBody" data-spy="scroll" data-target=".navMenuCollapse">
<!-- INTRO BLOCK -->
<header id="intro" class="intro-block bg-color1 dark-bg cover-bg">
<div class="container">
  <div class="row">
    <div class="col-md-6"> 
      <div class="logo">
        <img src="./images/icon.svg" alt="sent. logo" height="120"> 
      </div>
      <div class="slogan"><h1 style="color: rgb(255, 255, 255); font-size: 50px; background-color: rgba(0, 0, 0, 0); margin-bottom: 10px; margin-top: 20px; font-family: Lato;">Одна фраза - на всё. <br>
Навсегда.
</h1>
<p style="color: rgb(255, 255, 255); font-size: 17px; background-color: rgba(0, 0, 0, 0); font-family: Helvetica;" src="./images/icon.png">
Sent. - это мини-приложение VK, в котором можно отправлять только одно сообщение. Заинтригованы?
</p></div>
      <a class="download-btn" href="https://vk.com/app8013137" target="_blank" style="color: rgb(255, 255, 255); border-color: rgb(255, 255, 255); border-width: 0px; border-radius: 5px; font-size: 13px; background-color: rgb(0, 0, 0);" src="./images/icon.png"><i class="icon icon-vk" style="color: rgb(255, 255, 255); font-size: 40px; opacity: 1;" src="./images/icon.png" id="ui-id-5"></i>Попробуйте на платформе<b>ВКонтакте</b></a>
      <a class="download-btn" href="https://github.com/jeuub/sent" target="_blank" style="color: rgb(255, 255, 255); border-color: rgb(255, 255, 255); border-width: 0px; border-radius: 5px; font-size: 13px; background-color: rgb(0, 0, 0);" src="./images/icon.png"><i class="icon icon-github" style="color: rgb(255, 255, 255); font-size: 40px; opacity: 1;" src="./images/icon.png" id="ui-id-6"></i>Исходный код<b>GitHub</b></a>
    </div>
  </div>
</div>
<div class="container-half container-half-right contain-bg" style="background-image: url(&quot;images/intro-screen.png&quot;);"></div>
</header><!-- CONTENT-RIGHT BLOCK -->
<section id="content-right">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <img class="screen" src="images/screen-1.png" alt="screen"> 
      </div>
      <div class="col-md-5 col-md-offset-1">
        <div class="editContent"><h2>Просто показываю</h2>
<h4 class="sub-title">красивое...</h4>
<p class="sep-bottom">
Совместное творчество даёт простор для воображения и позволяет креативить в своё удовольствие. У нас люди не просто общаются и знакомятся, они обретают совершенно новую площадку для самовыражения и экспериментов. Ждите мемы и прочие приколы! Это приложение ещё удивит.
</p></div>
        <a class="btn btn-default btn-lg" href="https://vk.com/app8013137" target="_blank" style="color: rgb(0, 154, 204); border-color: rgb(0, 154, 204); border-width: 1px; border-radius: 5px; font-size: 20px; background-color: rgba(0, 0, 0, 0);" src="./images/icon.png">Онлайн бесплатно <i class="icon right-icon icon-chat" style="color: rgb(0, 154, 204); font-size: 20px; opacity: 1;" src="./images/icon.png" id="ui-id-12"></i></a>
      </div>
    </div>
  </div>
</section><!-- BENEFITS GRID IMAGES BLOCK-->
<section id="benefits-grid-images">
  <div class="container">
    <div class="row">
      <div class="col-sm-4">
        <ul class="item-list-center">
          <li><img src="images/feature1.png" width="120" alt="feature" class="screen">
<h3>Fully Responsive</h3>
            Доступно и удобно на устройствах любого размера.
<br>
<br></li>
          <li><img src="images/feature2.png" width="120" alt="feature" class="screen">
<h3>Open Source</h3>
            У проекта открытый исходный код - всё прозрачно!
<br>
<br></li>
        </ul>
      </div>
      <div class="col-sm-4">
        <ul class="item-list-center">
          <li><img src="images/feature3.png" width="120" alt="feature" class="screen">
<h3>Pure &amp; Simple</h3>
            Всё настолько легко, что разберётся любой!
<br>
<br></li>
          <li><img src="images/feature4.png" width="120" alt="feature" class="screen">
<h3>Documentation</h3>
В разработке документация проекта.
<h3></h3></li>
        </ul>
      </div>
      <div class="col-sm-4">
        <ul class="item-list-center">
          <li><img src="images/feature5.png" width="120" alt="feature" class="screen">
<h3>Color Schemes</h3>
            Приложение доступно в светлой и тёмной теме.
<br>
<br></li>
          <li><img src="images/feature6.png" width="120" alt="feature" class="screen">
<h3>Multiplatform</h3>
            Приложение работает на всех устройствах.
<br>
<br></li>
        </ul>
      </div>
    </div>
  </div>
</section><!-- TEAM CIRCLE BLOCK -->
<section id="team-circle" class="text-center team-block">
  <div class="container">
    <h2 class="title">Team</h2>
    <div class="row">
      <div class="col-sm-4">
        <img src="images/photo-team-1.webp" class="screen" alt="Team 1" width="250">
        <h3 class="name">Эййюб Бодур</h3>
        <h4 class="occupation">Full-stack разработчик</h4>
        <p class="editContent">Разработал базовую архитектуру проекта. Покинул команду, но всё ещё остаётся важной частью проекта.</p>
        <ul class="soc-list">
          <li><a href="https://github.com/jeuub" target="_blank"><i class="icon icon-github" style="color: rgb(0, 0, 0); font-size: 25px; opacity: 1;" ></i></a></li>
          <li><a href="https://t.me/meowken" target="_blank"><i class="icon icon-paper-plane" style="color: rgb(61, 133, 198); font-size: 25px; opacity: 1;" ></i></a></li>
        </ul>
      </div>
      <div class="col-sm-4">
        <img src="images/photo-team-2.webp" class="screen" alt="Team 2" width="250">
        <h3 class="name">Матвей Бухарцев</h3>
        <h4 class="occupation">Full-stack разработчик</h4>
        <p class="editContent">Основатель и лицо проекта. Сейчас работает над исправлением ошибок, к нему все претензии</p>
        <ul class="soc-list">
          <li><a href="https://github.com/bouhartsev" target="_blank"><i class="icon icon-github" style="color: rgb(0, 0, 0); font-size: 25px; opacity: 1;" ></i></a></li>
          <li><a href="https://bouhartsev.top" target="_blank"><i class="icon icon-dribbble2"></i></a></li>
          <li><a href="https://t.me/bouhartsev" target="_blank"><i class="icon icon-paper-plane" style="color: rgb(61, 133, 198); font-size: 25px; opacity: 1;" ></i></a></li>
        </ul>
      </div>
      <div class="col-sm-4">
        <img src="images/photo-team-3.webp" class="screen" alt="Team 3" width="250">
        <h3 class="name">Руслан Адигамов</h3>
        <h4 class="occupation">Front-end разработчик</h4>
        <p class="editContent">Вдохновился миссией проекта, кропотливо работал над интерфейсом проекта. До своего ухода.</p>
        <ul class="soc-list">
          <li><a href="https://github.com/AdRuslan" target="_blank"><i class="icon icon-github" style="color: rgb(0, 0, 0); font-size: 25px; opacity: 1;" ></i></a></li>
          <li><a href="https://t.me/Mashiro1499" target="_blank"><i class="icon icon-paper-plane" style="color: rgb(61, 133, 198); font-size: 25px; opacity: 1;" ></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</section><!-- FOOTER CENTER -->
<footer id="footer-center" class="text-center bg-color1 dark-bg">
  <div class="container"> 
    Matvey Bouhartsev © 2022
  </div>
</footer></div>
<!-- /#wrap -->
<!-- JavaScript -->
<script src="scripts/jquery-1.11.2.min.js"></script>
<script src="scripts/bootstrap.min.js"></script>
<script src="scripts/jquery.validate.min.js"></script>
<script src="scripts/jquery.smooth-scroll.min.js"></script>
<script src="scripts/placeholders.jquery.min.js"></script>
<script src="scripts/jquery.magnific-popup.min.js"></script>
<script src="scripts/jquery.counterup.min.js"></script>
<script src="scripts/waypoints.min.js"></script>
<script src="scripts/video.js"></script>
<script src="scripts/bigvideo.js"></script>
<script src="scripts/animations/wow.min.js"></script>
<script src="scripts/jquery.jCounter-0.1.4.js"></script>
<script src="scripts/bootstrap-datepicker.min.js"></script>
<script src="scripts/audio.min.js"></script>
<script src="scripts/goodshare.min.js"></script>
<script src="scripts/custom.js"></script>

</div>`,
};

const Landing = () => {
  return <div dangerouslySetInnerHTML={htmlDoc} />;
};

export default Landing;
